<template>
    <div id="adobe-dc-view" style="height: 560px; width: 100%" v-loading="loading"></div>
</template>
<script>
export default {
    name: "adobe-pdf",
    props: {
        path: String,
        url: String,
        fullUrl: String
    },
    data() {
        return {
            loading: false
        };
    },
    mounted() {
        console.clear();
        console.log(this.getPdfSourceUrl());
        this.loading = true;
        this.$loadScript("https://documentservices.adobe.com/view-sdk/viewer.js").then(
            () => {
                document.addEventListener(
                    "adobe_dc_view_sdk.ready",
                    () => this.getPdf()
                );
            }
        );
    },
    methods: {
        getPdfSourceUrl() {
            if (this.fullUrl) {
                if (this.fullUrl.startsWith("http://") || this.fullUrl.startsWith("https://")) {
                    return this.fullUrl;
                }
                return `${process.env.VUE_APP_API_URL}/${this.fullUrl}`.replace(/([^:]\/)\/+/g, "$1");
            }
            return `${process.env.VUE_APP_API_URL}/${this.path}/${this.url}`.replace(/([^:]\/)\/+/g, "$1");
        },
        getPdf() {
            setTimeout(() => {
                let adobeDCView = new AdobeDC.View({
                    clientId: process.env.VUE_APP_ADOBE_PDF_CLIENT_ID,
                    divId: "adobe-dc-view"
                });
                let pdfEmbedOptions = {
                    embedMode: "SIZED_CONTAINER",
                    showAnnotationTools: false,
                    showDownloadPDF: false,
                    showPrintPDF: false
                    //showLeftHandPanel: false,
                    //dockPageControls: false
                };
                this.loading = false;
                adobeDCView.previewFile(
                    {
                        content: {
                            location: {
                                url: this.getPdfSourceUrl()
                            }
                        },
                        metaData: { fileName: this.url || "document.pdf" }
                    },
                    pdfEmbedOptions
                );
            }, 2000);
        }
    }
};
</script>
<style>
@media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {
    #adobe-dc-view{
        height: 100% !important;
    }
}

</style>
